import { render, staticRenderFns } from "./CloseIcon.vue?vue&type=template&id=2a3c061c"
import script from "./CloseIcon.vue?vue&type=script&lang=js"
export * from "./CloseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports